export interface BulkActionOptions {
  path: string
  body: object
}

export class BulkAction {
  path: string
  body: object

  constructor({ path, body }: BulkActionOptions) {
    if (!path) {
      throw (new Error(), 'you must specify a path')
    }
    this.path = path
    this.body = body || {}
  }
}
